import React, { FC } from "react";

import { Future } from "../../../../state";
import TextField from "../TextField";
import HopeScoreSelector from "../HopeScoreSelector";
import QuestionHeader from "../QuestionHeader";
import useFormItemEditor from "../../../../hooks/useFormItemEditor";
import { ReactComponent as IconCross } from "../../../../assets/images/Career/ChallengeSheet/icon_cross.svg";
import { ReactComponent as IconPlus } from "../../../../assets/images/Career/ChallengeSheet/icon_plus.svg";
import styles from "../ChallengeSheetsModal.module.scss";

type Props = {
  futures: Future[];
  setFutures: (futures: Future[]) => void;
};

const SheetFutures: FC<Props> = ({ futures, setFutures }) => {
  const createFuture = (set_no: number): Future => ({
    set_no,
    when_where: "",
    what: "",
    reason: "",
    score: 1,
  });

  const {
    updateItem: updateFuture,
    addItem: addFuture,
    removeItem: removeFuture,
  } = useFormItemEditor<Future>(futures, setFutures, createFuture);

  return (
    <div className={styles.content}>
      <QuestionHeader
        title={"Q2.自分の未来について考えてみましょう。"}
        note={
          "学校を卒業して社会に出た後、自分はどんな大人になっていたいだろう？\n仕事、生活の様子、住んでいる場所など、思いつくことを入力してみましょう。\n ※複数ある場合は項目を追加しましょう。"
        }
      />
      <div className={styles.form}>
        <div className={styles.formList}>
          {futures.map((future, index) => (
            <div key={future.set_no} className={styles.formItem}>
              {futures.length > 1 && (
                <button
                  className={styles.removeButton}
                  onClick={() => removeFuture(index)}
                >
                  <IconCross />
                </button>
              )}
              <div className={styles.fieldset}>
                <p className={styles.legend}>将来どんなことをしてみたい？</p>
                <TextField
                  id={`when-where-${future.set_no}`}
                  label="いつ、どこで"
                  placeholder="10年後、沖縄で"
                  value={future.when_where}
                  onChange={e =>
                    updateFuture(index, { when_where: e.target.value })
                  }
                />
                <TextField
                  id={`what-${future.set_no}`}
                  label="何をしていたい？"
                  placeholder="料理店経営"
                  value={future.what}
                  onChange={e => updateFuture(index, { what: e.target.value })}
                />
              </div>
              <div className={styles.fieldset}>
                <TextField
                  id={`reason-${future.set_no}`}
                  label="理由（任意）"
                  placeholder="海が綺麗で楽しそうだから"
                  value={future.reason ?? ""}
                  onChange={e =>
                    updateFuture(index, { reason: e.target.value })
                  }
                />
              </div>
              <div className={styles.fieldset}>
                <HopeScoreSelector
                  name={`score-${future.set_no}`}
                  value={future.score}
                  onChange={e =>
                    updateFuture(index, { score: Number(e.target.value) })
                  }
                />
              </div>
            </div>
          ))}
        </div>
        <button className={styles.itemAddButton} onClick={() => addFuture()}>
          <IconPlus />
          項目を追加する
        </button>
      </div>
    </div>
  );
};

export default SheetFutures;
